import { isValidStudentPassword } from "@/entities/tutor_password_policy";

/** 英数字 16 文字。英字と数字の両方を含むまで作り直し、パスワードの条件を必ず満たす */
export function generateRandomPassword(): string {
  const str = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const num = 16;
  for (;;) {
    const password = Array.from(crypto.getRandomValues(new Uint8Array(num)))
      .map(n => str[n % str.length])
      .join("");
    if (isValidStudentPassword(password)) return password;
  }
}

/** 生徒のパスワードを新しく作る・変えるときの条件（先生と同じ。ログインでは確かめない） */
export function validPassword(password: string): boolean {
  return isValidStudentPassword(password);
}
